"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearWeekSelector = void 0;
var React = require("react");
var Layouts_1 = require("../../../Layouts");
var Localization_1 = require("../../../Localization");
var Dropdown_1 = require("../../Dropdown");
var ChartRangeDropdownPicker_context_1 = require("../ChartRangeDropdownPicker.context");
var WeekSelector_1 = require("./WeekSelector");
var YearWeekSelector_styles_1 = require("./YearWeekSelector.styles");
var YearWeekSelector = function (_a) {
    var Data = _a.Data, OnSearch = _a.OnSearch, OnSearchCancel = _a.OnSearchCancel, MinSelectableYearNumber = _a.MinSelectableYearNumber, _b = _a.MinSelectableDateNumber, MinSelectableDateNumber = _b === void 0 ? -1 : _b, Caption = _a.Caption, YearAriaLabel = _a.YearAriaLabel, WeekSearchAriaLabel = _a.WeekSearchAriaLabel, WeekAriaLabel = _a.WeekAriaLabel, OnYearChange = _a.OnYearChange, OnWeekChange = _a.OnWeekChange;
    var AvailableDates = ChartRangeDropdownPicker_context_1.useChartRangeDropdownPicker().AvailableDates;
    var handleYearChanges = function (value) {
        return OnYearChange(Number(value.Value));
    };
    return (React.createElement(Layouts_1.VStack, null,
        React.createElement(YearWeekSelector_styles_1.YearWeekCaptionDiv, null, Caption),
        React.createElement(Layouts_1.HStack, { AutoColumns: "143px auto", Gap: "small" },
            React.createElement(Layouts_1.VStack, { Gap: "xxSmall" },
                React.createElement(YearWeekSelector_styles_1.FieldLabelDiv, null, Localization_1.strings.ChartRangeDropDownPicker_Label_Year),
                React.createElement(Dropdown_1.Dropdown, { Appearance: "Reversed", AriaLabel: YearAriaLabel, OnChange: handleYearChanges, DropdownListItems: AvailableDates.Years.map(function (item) { return ({
                        Caption: item.toString(),
                        Disabled: MinSelectableYearNumber > item,
                        Value: item,
                    }); }), Value: Data.year })),
            React.createElement(Layouts_1.VStack, { Gap: "xxSmall" },
                React.createElement(YearWeekSelector_styles_1.FieldLabelDiv, null, Localization_1.strings.ChartRangeDropDownPicker_Label_Week),
                React.createElement(WeekSelector_1.WeekSelector, { Data: Data, WeekSearchAriaLabel: WeekSearchAriaLabel, AriaLabel: WeekAriaLabel, OnWeekChange: OnWeekChange, OnSearch: OnSearch, OnSearchCancel: OnSearchCancel, MinSelectableDateNumber: MinSelectableDateNumber })))));
};
exports.YearWeekSelector = YearWeekSelector;
